import { v4 as uuidv4 } from 'uuid';
import { formatFileSize } from './localFile.js';
import {
	getQiniuSignedUrl,
	resolveRawMediaUrl,
	resolveSignedPreviewUrl,
} from './qiniuMedia.js';

export function pickFilesizeByte(item = {}) {
	const raw = item.filesize_byte ?? item.filesizeByte;
	const byte = Number(raw);
	return Number.isFinite(byte) && byte >= 0 ? byte : 0;
}

export function pickFilesizeLabel(item = {}, byte = pickFilesizeByte(item)) {
	if (item.filesize) return item.filesize;
	if (byte > 0) return formatFileSize(byte);
	return '';
}

/** 本地 blob 预览项；已上传（含接口返回 id/url）视为非本地 */
export function isLocalMediaItem(item = {}) {
	if (item.local === false) return false;
	if (item.local === true) return true;
	if (item.url && !item.previewUrl?.startsWith('blob:')) return false;
	return Boolean(item.previewUrl?.startsWith('blob:'));
}

export function withMediaFileMeta(item = {}, fields = {}) {
	const byte = pickFilesizeByte(item) || pickFilesizeByte(fields);
	return {
		...fields,
		id: item.id || fields.id || uuidv4(),
		filename: item.filename || fields.filename || '',
		filesize: pickFilesizeLabel(item, byte) || pickFilesizeLabel(fields, byte),
		filesize_byte: byte,
	};
}

export function normalizeUploadedImageItem(item = {}, fallback = {}) {
	const rawUrl = resolveRawMediaUrl(item) || resolveRawMediaUrl(fallback) || '';
	return withMediaFileMeta(item, {
		previewUrl: resolveSignedPreviewUrl({ ...item, url: rawUrl }) || fallback.previewUrl || '',
		url: rawUrl || fallback.url || '',
		local: false,
	});
}

export function normalizeUploadedFileItem(item = {}, fallback = {}) {
	const rawUrl = resolveRawMediaUrl(item) || resolveRawMediaUrl(fallback) || '';
	const signedPreview = rawUrl ? getQiniuSignedUrl(rawUrl) : '';
	return withMediaFileMeta(item, {
		previewUrl: signedPreview || item.previewUrl || fallback.previewUrl || '',
		url: rawUrl || fallback.url || '',
		local: false,
	});
}

export function normalizeUploadedAudioItem(item = {}, fallback = {}) {
	const duration = item.duration ?? fallback.duration ?? 0;
	const rawUrl = resolveRawMediaUrl(item) || resolveRawMediaUrl(fallback) || '';
	return withMediaFileMeta(item, {
		previewUrl: resolveSignedPreviewUrl({ ...item, url: rawUrl }) || fallback.previewUrl || '',
		url: rawUrl || fallback.url || '',
		duration,
		durationText: item.durationText || fallback.durationText || '',
		local: false,
	});
}

export function normalizeUploadedVideoItem(item = {}, fallback = {}) {
	return normalizeUploadedAudioItem(item, fallback);
}
